import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import ax from 'services/apiService';

export const getCandidateList = createAsyncThunk('candidatelist', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/candidate`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getCandidateInternList = createAsyncThunk('candidatelist2', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/candidate`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getCandidateProjectLists = createAsyncThunk('candidatelist3', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/candidate`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const addCandidate = createAsyncThunk('add-candidate', async ({ formData, apiUrl }: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`upload`, formData);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const removeCandidate = createAsyncThunk('delete-candidate', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.delete(`api/api/menu/remove-candidate/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// getIndividualCandidate
export const getIndividualCandidate = createAsyncThunk('get-individual', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/menu/candidate/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getCandidateDetail = createAsyncThunk('get-candidate', async (id: number, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/exam_management/candidateresult/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const addInterviewDetails = createAsyncThunk('add-interview-comments', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/interviewinfo`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getInterviewDetail = createAsyncThunk('get-interview-comments', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/interviewinfolist`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const saveRegistrationForm = createAsyncThunk('reg-form', async ({ formData, apiUrl }: any) => {
    try {
        const { data } = await ax.post(`submit-public-form`, formData);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
// master_data/c_batchpaidamount
export const payAmount = createAsyncThunk('pay-form', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/c_batchpaidamount`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// master_data/c_batchpaidamountlist/99
export const getPaymentDetails = createAsyncThunk('payment-form', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/master_data/c_batchpaidamountlist/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// master_data/candidatebatchinfo/95
// master_data/candidate_bulk_upload
export const submitCandidBulkUpload = createAsyncThunk('candidate-bulk-upload', async ({ formData, apiUrl }: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`bulk-upload`, formData);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// master_data/c_projectpaidamount
export const payProjectAmount = createAsyncThunk('pay-project-intern', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/master_data/c_projectpaidamount`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// master_data/c_projectpaidamountlist/99
export const getPrjPaymentDetails = createAsyncThunk('proj-detail-payment-form', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/master_data/c_projectpaidamountlist/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// menu/applicant_list
export const getAllApplicant = createAsyncThunk('get-all-applicant', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/applicant_list`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// menu/dashapplicant_list
export const getApplicantDetails = createAsyncThunk('gjket-akll-dashapplicant_list', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/dashapplicant_list`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// menu/degree_list
export const getDegreeList = createAsyncThunk('degree_list', async () => {
    try {
        const { data } = await ax.get(`api/api/menu/degree_list`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.message;
        }
    }
});

// menu/candidate_types
export const getApplicantType = createAsyncThunk('get-alls-applicant-type', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/candidate_types`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/new_candidateresult
export const getCandidateResult = createAsyncThunk('get-alls-candidate-new-result-type', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/new_candidateresult`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});